import React from 'react';
import styled from 'styled-components';

const P = styled.p`
  font-size: ${props => props.theme?.paragraph?.fontSize || '14px'};
  line-height: ${props => props.theme?.paragraph?.lineHeight || '1.2rem'};
  margin: ${props => props.theme?.paragraph?.margin};
  color: ${props => props.theme?.paragraph?.color};
  font-weight: ${props => props.theme?.paragraph?.fontWeight};
`;

export default function Paragraph({children}) {
  return <P>{children}</P>
}
